import React, {FunctionComponent} from 'react'
import {Navbar} from "@App/Components/Navbar";
import {Footer} from "@App/Layouts/Footer";
import {Outlet} from "react-router-dom";
import {State} from "@App/state";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {NavbarDL} from "@App/Components/NavbarDL";

export const Layout: FunctionComponent = () => {
    const organization = useSelector((state: State) => state.orders.organization)
    const {t} = useTranslation()
    return (
        <div className="text-neutral-400">
            <NavbarDL>
                <div className={'flex items-center gap-4'}>
                    <a href={'https://werkstatt.repareo.de/partner/deutsche-leasing'} className={'flex'} title={"repareo Werkstattvergleich"}>
                        <img
                            src="/images/brand/logo-light.svg"
                            className="w-24 h-auto"
                            alt=""
                        />
                    </a>
                    <a href="http://www.deutsche-leasing.com/" title="Deutsche Leasing" target="_blank" className={"px-2 md:px-4"}>
                    <img src="/images/brand/deutsche-leasing-cooperation.png" className={"h-8 md:h-10"}
                        alt="Deutsche Leasing"/>
                    </a>
                </div>
            </NavbarDL>
            <Outlet/>
            <Footer/>
        </div>
    )
}
